// @core/api/endpoints/payment/charge_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChargeEntityRequest,
  PaymentLifecycleResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Charge entity
 * Initiates a payment charge for any entity with payment aspect. Routes to the best provider, processes the charge, and updates payment aspect status.
 */
export async function ChargeEntity(
  target_type: string,
  target_id: string,
  data: ChargeEntityRequest,
  options?: RequestOptions
): Promise<PaymentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment/:target_type/:target_id/charge`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<PaymentLifecycleResponse>(requestPath, data, requestOptions);
}
